import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavLink } from '../../../models/nav-link';
import { LanguageService } from '../../../_services/language.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fury-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
  navLinks: NavLink[] = [];

  private destroy$ = new Subject();


  constructor(public languageService: LanguageService) { }

  ngOnInit() {
    this.buildTabs();

    this.languageService.languageChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => this.buildTabs());
  }

  private buildTabs(): void {
    this.navLinks = [
      {
        path: 'globalreports',
        label: this.languageService.getLabel('report.ReportGlobale'),
        visible: true,
        disabled: false
      },
      // {
      //   path: 'collectionReports',
      //   label: this.languageService.getLabel('report.ReportPerCollezione'),
      //   visible: false,
      //   disabled: false
      // },
      {
        path: 'reports-history',
        label: this.languageService.getLabel('report.StoricoReportGenerati'),
        visible: true,
        disabled: false
      }
    ]
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
